

import { api } from '../client';
import {
  PushTemplate,
  PushTemplateCreateRequest,
  PushTemplateUpdateRequest,
  EventPushTrigger,
  EventTriggerCreateRequest,
  EventTriggerUpdateRequest,
  RecurringSchedule,
  RecurringScheduleCreateRequest,
  RecurringScheduleUpdateRequest,
  SchedulePreset,
  SchedulePresetCreateRequest,
  TriggerPresetCreateRequest,
  TriggerPreset,
} from '../../types/push_management.types';
import { SuccessResponse } from '../../types/api.types';

export const pushManagementApi = {
  templates: {
    create: async (data: PushTemplateCreateRequest): Promise<SuccessResponse & { template: PushTemplate }> => {
      const response = await api.post<SuccessResponse & { template: PushTemplate }>(
        '/push-templates',
        data
      );
      return response.data;
    },
    get: async (id: number): Promise<PushTemplate> => {
      const response = await api.get<PushTemplate>(
        `/push-templates/${id}`
      );
      return response.data;
    },
    list: async (appId: number): Promise<{ templates: PushTemplate[] }> => {
      const response = await api.get<{ templates: PushTemplate[] }>(
        '/push-templates',
        { params: { app_id: appId } }
      );
      return response.data;
    },
    update: async (id: number, data: PushTemplateUpdateRequest): Promise<SuccessResponse> => {
      const response = await api.put<SuccessResponse>(
        `/push-templates/${id}`,
        data
      );
      return response.data;
    },
    delete: async (id: number): Promise<SuccessResponse> => {
      const response = await api.delete<SuccessResponse>(
        `/push-templates/${id}`
      );
      return response.data;
    },
  },





  triggers: {
    create: async (data: EventTriggerCreateRequest): Promise<SuccessResponse & { trigger: EventPushTrigger }> => {
      const response = await api.post<SuccessResponse & { trigger: EventPushTrigger }>(
        '/event-triggers',
        data
      );
      return response.data;
    },
    get: async (id: number): Promise<EventPushTrigger> => {
      const response = await api.get<EventPushTrigger>(
        `/event-triggers/${id}`
      );
      return response.data;
    },
    list: async (appId: number): Promise<{ triggers: EventPushTrigger[] }> => {
      const response = await api.get<{ triggers: EventPushTrigger[] }>(
        '/event-triggers',
        { params: { app_id: appId } }
      );
      return response.data;
    },
    update: async (id: number, data: EventTriggerUpdateRequest): Promise<SuccessResponse> => {
      const response = await api.put<SuccessResponse>(
        `/event-triggers/${id}`,
        data
      );
      return response.data;
    },
    delete: async (id: number): Promise<SuccessResponse> => {
      const response = await api.delete<SuccessResponse>(
        `/event-triggers/${id}`
      );
      return response.data;
    },
  },





  schedules: {
    create: async (data: RecurringScheduleCreateRequest): Promise<SuccessResponse & { schedule: RecurringSchedule }> => {
      const response = await api.post<SuccessResponse & { schedule: RecurringSchedule }>(
        '/recurring-schedules',
        data
      );
      return response.data;
    },
    get: async (id: number): Promise<RecurringSchedule> => {
      const response = await api.get<RecurringSchedule>(
        `/recurring-schedules/${id}`
      );
      return response.data;
    },
    list: async (appId: number): Promise<{ schedules: RecurringSchedule[] }> => {
      const response = await api.get<{ schedules: RecurringSchedule[] }>(
        '/recurring-schedules',
        { params: { app_id: appId } }
      );
      return response.data;
    },
    update: async (id: number, data: RecurringScheduleUpdateRequest): Promise<SuccessResponse> => {
      const response = await api.put<SuccessResponse>(
        `/recurring-schedules/${id}`,
        data
      );
      return response.data;
    },
    delete: async (id: number): Promise<SuccessResponse> => {
      const response = await api.delete<SuccessResponse>(
        `/recurring-schedules/${id}`
      );
      return response.data;
    },
  },

  presets: {
    list: async (): Promise<{ presets: SchedulePreset[] }> => {
      const response = await api.get<{ presets: SchedulePreset[] }>('/schedule-presets');
      return response.data;
    },

    get: async (id: number): Promise<SchedulePreset> => {
      const response = await api.get<SchedulePreset>(`/schedule-presets/${id}`);
      return response.data;
    },

    create: async (data: SchedulePresetCreateRequest): Promise<SuccessResponse & { preset: SchedulePreset }> => {
      const response = await api.post<SuccessResponse & { preset: SchedulePreset }>(
        '/schedule-presets',
        data,
      );
      return response.data;
    },

    update: async (
      id: number,
      data: Partial<SchedulePresetCreateRequest>,
    ): Promise<SuccessResponse> => {
      const response = await api.put<SuccessResponse>(`/schedule-presets/${id}`, data);
      return response.data;
    },

    delete: async (id: number): Promise<SuccessResponse> => {
      const response = await api.delete<SuccessResponse>(`/schedule-presets/${id}`);
      return response.data;
    },
  },
  triggerPresets: {
    list: async (): Promise<{ presets: TriggerPreset[] }> => {
      const response = await api.get<{ presets: TriggerPreset[] }>('/trigger-presets');
      return response.data;
    },
    get: async (id: number): Promise<TriggerPreset> => {
      const response = await api.get<TriggerPreset>(`/trigger-presets/${id}`);
      return response.data;
    },
    create: async (data: TriggerPresetCreateRequest): Promise<SuccessResponse & { preset: TriggerPreset }> => {
      const response = await api.post<SuccessResponse & { preset: TriggerPreset }>('/trigger-presets', data);
      return response.data;
    },
    update: async (id: number, data: Partial<TriggerPresetCreateRequest>): Promise<SuccessResponse> => {
      const response = await api.put<SuccessResponse>(`/trigger-presets/${id}`, data);
      return response.data;
    },
    delete: async (id: number): Promise<SuccessResponse> => {
      const response = await api.delete<SuccessResponse>(`/trigger-presets/${id}`);
      return response.data;
    },
  },
  cancelScheduledPush: async (messageId: string): Promise<SuccessResponse> => {
    const response = await api.post<SuccessResponse>(
      `/push/${messageId}/cancel`
    );
    return response.data;
  },
};